import { Component, Input, HostBinding, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/shared/services/general.service';
import { AdDefaults } from '../ad-default';


@Component({
    selector: 'tour',
    templateUrl: './tour.component.html',
    styleUrls: ['./tour.component.scss']
})
export class TourComponent extends AdDefaults implements OnInit {


    @Input() info : any;
    @Input() images : any = null;
    @HostBinding('className') className = '';

    viewInit = false;

    tourSelected:any = {};

    constructor( 
        protected gs : GeneralService
    ){
        super(gs);
    }


    ngOnInit(){

        if(!!this.info?.tour?.length)
            this.tourSelected = this.info?.tour[0];

        super.ngOnInit();
    }

    openTour(slide){
        this.tourSelected = slide;
    }

}